const configEnv = {
  env: process.env.NODE_ENV || 'dev',
  isProd: process.env.NODE_ENV === 'production',
  rootApi: process.env.VUE_APP_ROOT_API, 
  socketUrl: process.env.VUE_APP_SOCKET_URL,
  serverlessUrl: process.env.VUE_APP_SERVER_URL_DEV,
  tokenKey: process.env.VUE_APP_KEY_TOKEN_LOCALSTORAGE,
  userDataKey: process.env.VUE_APP_KEY_USERDATA_LOCALSTORAGE,
  tableauServer: process.env.VUE_APP_TABLEAU_SERVER,
}

module.exports = { configEnv }